import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedModule } from '@app/shared';
import { Observable } from 'rxjs';
import { LoadingComponent } from './core/components/loading/loading.component';
import { LoadingService } from './core/services';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [SharedModule, LoadingComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  public isLoading$: Observable<boolean>;

  constructor(private loadingService: LoadingService) {
    this.isLoading$ = this.loadingService.loading$;
  }
}
